// This can be changed to version the API: `/api/v1`, etc.
export const API_PREFIX = "/api";
